import { Component } from '@angular/core';

@Component({
    selector: 'app-failpass',
    templateUrl: './failpass.component.html',
    styleUrls: ['./failpass.component.scss'],
    standalone: false
})
export class FailpassComponent {

}
